var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.535 2.51814L13.505 2.58814L10.605 9.31814H7.75496C7.07496 9.31814 6.42496 9.45814 5.83496 9.70814L7.58496 5.52814L7.62496 5.42814L7.69496 5.26814C7.71496 5.20814 7.73496 5.14814 7.76496 5.09814C9.07496 2.06814 10.555 1.37814 13.535 2.51814Z",
    stroke: "#CCD1D1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9255 9.51856C18.4755 9.37856 17.9955 9.31855 17.5155 9.31855H10.6055L13.5055 2.58855L13.5355 2.51855C13.6855 2.56855 13.8255 2.63855 13.9755 2.69855L16.1855 3.62855C17.4155 4.13855 18.2755 4.66855 18.7955 5.30855C18.8955 5.42855 18.9755 5.53855 19.0455 5.66855C19.1355 5.80855 19.2055 5.94855 19.2455 6.09855C19.2855 6.18855 19.3155 6.27855 19.3355 6.35855C19.6055 7.19855 19.4455 8.22856 18.9255 9.51856Z",
    stroke: "#CCD1D1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3967 14.1984V16.1484C22.3967 16.3484 22.3867 16.5484 22.3767 16.7484C22.1867 20.2384 20.2367 21.9984 16.5367 21.9984H8.73672C8.49672 21.9984 8.25672 21.9784 8.02672 21.9484C4.84672 21.7384 3.14672 20.0384 2.93672 16.8584C2.90672 16.6284 2.88672 16.3884 2.88672 16.1484V14.1984C2.88672 12.1884 4.10672 10.4584 5.84672 9.70836C6.44672 9.45836 7.08672 9.31836 7.76672 9.31836H17.5267C18.0167 9.31836 18.4967 9.38836 18.9367 9.51836C20.9267 10.1284 22.3967 11.9884 22.3967 14.1984Z",
    stroke: "#CCD1D1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.585 5.52832L5.835 9.70832C4.095 10.4583 2.875 12.1883 2.875 14.1983V11.2683C2.875 8.42832 4.895 6.05832 7.585 5.52832Z",
    stroke: "#CCD1D1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3936 11.2677V14.1977C22.3936 11.9977 20.9336 10.1277 18.9336 9.52766C19.4536 8.22766 19.6036 7.20766 19.3536 6.35766C19.3336 6.26766 19.3036 6.17766 19.2636 6.09766C21.1236 7.05766 22.3936 9.02766 22.3936 11.2677Z",
    stroke: "#CCD1D1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavings);
export default __webpack_public_path__ + "static/media/savings.2ada5e3139bd872214fd674193a2f2d4.svg";
export { ForwardRef as ReactComponent };